@use '@design/design-tokens/typography/typography' as *;

$shadow-color: #6592fd;

.styledHeaderNavigation {
  z-index: var(--z-index-sidebar);
}

.moreDropdownLabel {
  color: var(--text-default);
  white-space: nowrap;
  @include typography-v2-body-base;
}

.moreDropdownContainer {
  display: flex;
  gap: 10px;
  align-items: center;
}

.counterBadge {
  position: relative;
  z-index: 1;

  [data-badge='numerical'] {
    background-color: $shadow-color;
    box-shadow: 0 0 5px 1px $shadow-color;
  }

  &.withError [data-badge='numerical'] {
    box-shadow: none;
  }
}

.errorBadge {
  position: absolute;
  right: 0;

  &.withCounterBadge {
    right: 11px;
  }

  [data-badge='numerical'] {
    background-color: var(--icon-critical);
  }
}
